
import React, { Component } from 'react';
import { Modal } from 'reactstrap';
import { IoIosCloseCircleOutline } from "react-icons/io"
import { FaCheckCircle } from "react-icons/fa";

const stateManager = require('../../../../utils/state/stateManager');
const constants = require('../../../../utils/domain/constants');
const stringUtil = require('../../../../utils/string/stringUtil');

class OrderConfirmation extends Component 
{
    constructor(props)
    {
        super(props);
    }

    render()
    {
        if(stringUtil.areStringSame(stateManager.getStore().getState().currentMode, constants.applicationMode.overPhonePayment))
        {
            var state = stateManager.getStore().getState();
            return  <div style={{background: `var(--background-color)`}}>
                        <div className='AppBar'>                                
                            <div  style={{paddingLeft:'10px', paddingRight:'10px',paddingTop:'5px'}}>
                                <div>{state.property.name}</div>
                                <div className='smallText'>{state.property.address}</div>
                            </div>

                            <hr style={{marginTop:'5px', marginBottom:'0px'}}/> 
                        </div>
                        
                        <div style={{marginTop:'80px', marginLeft:'15px', marginRight:'15px', textAlign:'center'}}>
                            <div>
                                <FaCheckCircle size={48} color="#50C878"/>
                            </div>

                            <div style={{marginTop:'10px'}}><h3>Thank You!</h3></div>
                            <div>Order successfully sent to Kitchen</div>
                            <div style={{marginTop:'10px'}}>Your Order Number is <b>{state.lastOrderNumber}</b></div>
                            {
                                stringUtil.areStringSame(stateManager.getStore().getState().currentMode, constants.applicationMode.overPhonePayment)
                                    ? <h4 style={{marginTop:'20px'}}>Please close the page.</h4>
                                    : null
                            }
                        </div>
                    </div>
        }
        else
        {   
            return <Modal isOpen={true} centered >
                    <div className='AppBar'>
                        <table style={{width:'100%'}}>
                            <tr>
                                <td style={{width:'99%'}}>
                                    <div style={{paddingLeft:'10px', paddingRight:'10px',paddingTop:'5px', paddingBottom:'5px'}}>
                                        Order Confirmation
                                    </div>

                                </td>

                                <td style={{whiteSpace:'nowrap'}}>
                                    <div style={{marginTop:'5px', marginLeft:'10px', marginRight:'5px', fontSize:`var(--button-close-size)`, color:`var(--button-close-color)`}}
                                        onClick={()=>
                                                {
                                                    this.props.onClose();
                                                }}>
                                        <IoIosCloseCircleOutline/>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    {this.renderBody()}
                </Modal>
        }
    }

    renderBody()
    {
        var state = stateManager.getStore().getState();
        return <div style={{marginTop:'40px', marginBottom:'40px', marginLeft:'15px', marginRight:'15px', textAlign:'center'}}>
                    <div>
                        <FaCheckCircle size={48} color="#50C878"/>
                    </div>

                    <div style={{marginTop:'10px'}}><h3>Thank You!</h3></div>
                    <div>Order successfully sent to Kitchen</div>
                    <div style={{marginTop:'10px'}}>Your Order Number is <b>{state.lastOrderNumber}</b></div>
                </div>
    }
}

export default OrderConfirmation;